import { render, staticRenderFns } from "./Cashire_entity.vue?vue&type=template&id=62bcbfbd&scoped=true&"
import script from "./Cashire_entity.vue?vue&type=script&lang=js&"
export * from "./Cashire_entity.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62bcbfbd",
  null
  
)

export default component.exports